<template>
  <div class="user-email-register">
   <div class="form-field field-account">
      <div class="addion">
        <i class="fa fa-envelope-o"></i>
      </div>
      <input v-model="email" type="text" :placeholder="$t('请输入邮箱')">
    </div>
    <div class="form-field field-password">
      <div class="addion">
        <i class="fa fa-lock"></i>
      </div>
      <input v-model="password" type="password" :placeholder="$t('请输入密码')">
    </div>
    <div class="form-field field-confirmPassword">
      <div class="addion">
        <i class="fa fa-lock"></i>
      </div>
      <input v-model="confirmPassword" type="password" :placeholder="$t('确认密码')">
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmailRegister',
  data() {
    return {
      email: '',
      password: '',
      confirmPassword: '',
    }
  },
  computed: {
    valid() {
      return this.email && this.password && this.confirmPassword && this.password === this.confirmPassword
    }
  },
  methods: {
    getFormData() {
      return {
        email: this.email,
        account: this.email,
        password: this.password,
        confirmPassword: this.confirmPassword,
      }
    }
  }
}
</script>